import request from "@/utils/http";

// 添加活动
export function activityApply(data) {
  return request.post("/promotion/apply", data);
}

// 修改活动
export function activityEdit(data) {
  return request.post("/promotion/update", data);
}

// 获取系统默认的服务项目
export function serviceItem() {
  return request.get("/promotion/service-item/default").then(res => res.result);
}

// 活动列表
export function activityList() {
  return request.get("/promotion/list").then(res => res.result);
}

// 活动详情
export function activityDetail(id) {
  return request.get(`/promotion/${id}`).then(res => res.result);
}

// 关闭开启分销
export function distribution(data) {
  return request.get(
    `/promotion/enableReward?id=${data.id}&enabled=${data.enabled}`
  );
}

// 复制活动
export function copyPromotion(id) {
  return request.post(`/promotion/copyPromotion?id=${id}`);
}

// 删除活动
export function deletePromotion(id) {
  return request.post(`/promotion/delete/${id}`);
}
